module.exports = __webpack_public_path__ + "static/media/sirsasana.af9c3fd1.jpg";